import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { invokeEvent } from 'shared-base';
import { Json } from '../../types';
import { ContentAssetPacks } from './ContentAssetPacks';

export type ContentAssetPacksContainerProps = {};

export function ContentAssetPacksContainer(_props: ContentAssetPacksContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const assetPacks = useSelector(selectors.gallery.$assetPacks);
  const isLoading = useSelector(selectors.raw.$rawAppState).isLoading;

  const callbacks = useMemo(
    () => ({
      onClick: (item: Json) => {
        invokeEvent('nav', { path: `/playground/packs/${item.id}` });
      },
    }),
    []
  );

  return <ContentAssetPacks assetPacks={assetPacks} isLoading={isLoading} callbacks={callbacks} />;
}

export default ContentAssetPacksContainer;
